import React from "react";
import { RegularButton, Topbar, TopBarProps } from "@components";
import { CustomerRefFragment } from "@graphql";
import locale from "@bonliva-crm/locale";
import { ArrowUpward } from "@material-ui/icons";
import { customerCanGoTop } from "./customerCanGoTop";
import { useNavigation } from "@navigation";

type Props = TopBarProps & {
  customerParents: CustomerRefFragment[];
};

export function CustomerTopbar(props: Props) {
  const { customerParents, ...rest } = props;
  const navigator = useNavigation();
  const { canGoTop, hideBackBtn, onTop, parentName } = customerCanGoTop(
    customerParents,
    navigator
  );

  return (
    <Topbar {...rest}>
      {({ backBtn, closeBtn }) => (
        <>
          {closeBtn}
          {!hideBackBtn && backBtn}

          {canGoTop && (
            <RegularButton
              aria-label={locale.Top(parentName)}
              onClick={onTop}
              data-test="BackButton"
              leftIcon={<ArrowUpward fontSize="small" />}
              variant="text"
            >
              {locale.Top(parentName)}
            </RegularButton>
          )}
        </>
      )}
    </Topbar>
  );
}
